// Criticidad pill S1–S4 for the postventa panel. Distinct from `.st-pill`
// (facility status semáforo): the code sits in a mono key chip and the
// four levels get four distinct colours (founder decision). Label and
// tone come from the shared module (`CRITICIDAD_LABEL` / `CRITICIDAD_TONE`
// in @bitacorapro/api-types); the tone → class map is ../lib/postventa/pills.
//
// `hideCode` drops the «S1» chip: the observation card follows the
// handoff, which removes the S-codes from the visible vocabulary (README
// §3). Tables keep the chip for scanning.

import { CRITICIDAD_LABEL, CRITICIDAD_TONE } from "@bitacorapro/api-types";
import { SEV_PILL_CLASS } from "../lib/postventa/pills";
import type { SeverityCode } from "../lib/postventa/severity";

export function SevPill({
  code,
  showName = true,
  hideCode = false,
}: {
  code: SeverityCode | null;
  showName?: boolean;
  hideCode?: boolean;
}) {
  if (code === null) {
    return (
      <span className="sev-pill sev-pill--none">
        {!hideCode && <span className="sev-pill__k">—</span>}
        Sin criticidad
      </span>
    );
  }
  return (
    <span className={`sev-pill ${SEV_PILL_CLASS[CRITICIDAD_TONE[code]]}`}>
      {!hideCode && <span className="sev-pill__k">{code}</span>}
      {(showName || hideCode) && CRITICIDAD_LABEL[code]}
    </span>
  );
}
